// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inherited-input[data-v-2ed38275] {\n  width: 100%;\n  display: flex;\n}\n.input-part[data-v-2ed38275] {\n  flex-grow: 1;\n}\n.switch-part[data-v-2ed38275] {\n  width: 100px;\n  text-align: center;\n  flex-shrink: 0;\n}\n.switch-part label[data-v-2ed38275] {\n  margin-bottom: 16px;\n  width: 100%;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
